var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.availableCategories, function(group) {
      return _c("div", { key: group.label }, [
        _c("h5", [_vm._v("\n      " + _vm._s(_vm.$t(group.label)) + "\n    ")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row m-0 mb-3" },
          _vm._l(group.options, function(category) {
            return _c(
              "div",
              {
                key: category.name,
                class:
                  "col-md-4 " +
                  _vm.getCategoryClass(category.connected) +
                  " category-item",
                attrs: {
                  "data-v-step": "campaign.create.category." + category.number
                }
              },
              [
                _c("campaign-pholder", {
                  attrs: { connectable: category.connected, site: category },
                  on: { selectCategory: _vm.selectCategory }
                })
              ],
              1
            )
          }),
          0
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f754ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f754ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/CampaignCategory.vue
// module id = null
// module chunks = 